import styles from "./Header.module.css";
import { useEffect, useState } from "react";
import logo from "../media/cart7_logo_white.png";


function Header() {
  const [CheckOnce, setCheckOnce] = useState(false);
  const [CartUpdate, setCartUpdate] = useState(false);
  const [Cart, setCart] = useState(null);

  const Lcart = localStorage.getItem("cart");

  if(!CheckOnce) {
    setCheckOnce(true);
  }
  useEffect(()=>{
    const cartID = crypto.randomUUID();
    if(!Lcart) return localStorage.setItem("cart", JSON.stringify({id: cartID, items:[]}));
    const cart = JSON.parse(Lcart);
    setCart(cart);
    if(Lcart && CheckOnce && cart.items?.length>0) {
      setCartUpdate(true);
      const update = setTimeout(()=>{
        setCartUpdate(false);
      }, 500);
      return ()=>clearTimeout(update);
    }
  }, [CheckOnce, Lcart]);

  return(
    <div className={styles.headerWrapper}>
      <a href="/" title="Visit Home page"><img className={styles.logo} src={logo} alt="logo" /></a>
      <div className={styles.menuBtn}>
        <a href="/contact" title="Contact us">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="white" viewBox="0 0 24 24">
  <path fillRule="evenodd" d="M3.559 4.544c.355-.35.834-.544 1.33-.544H19.11c.496 0 .975.194 1.33.544.356.35.559.829.559 1.331v9.25c0 .502-.203.981-.559 1.331-.355.35-.834.544-1.33.544H15.5l-2.7 3.6a1 1 0 0 1-1.6 0L8.5 17H4.889c-.496 0-.975-.194-1.33-.544A1.868 1.868 0 0 1 3 15.125v-9.25c0-.502.203-.981.559-1.331ZM7.556 7.5a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2h-8Zm0 3.5a1 1 0 1 0 0 2H12a1 1 0 1 0 0-2H7.556Z" clipRule="evenodd"/>
</svg>

        Contact Us</a>
      </div>
      <div className={`${styles.cartIcon}`}>
        <a href="/my-cart" title="My Cart" className={`${styles.cart} ${CartUpdate?styles.cartUpdate:""}`}>
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
  <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5M3.102 4l1.313 7h8.17l1.313-7zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4m7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>
</svg>
        {Cart&&Cart.items?.length>0?<span>{Cart.items?.length}</span>:""}
        </a>
      </div>
    </div>
  );
}

export default Header;